import React from 'react';
import { Helmet } from 'react-helmet-async';

// SEO-Konfiguration für alle Seiten
export const seoConfig = {
  siteName: 'Erste Hilfe Bottrop',
  siteUrl: 'https://erstehilfebottrop.de',
  defaultImage: 'https://erstehilfebottrop.de/og-image.jpg',
  locale: 'de_DE',
  twitterHandle: '@erstehilfebottrop',
  
  // Strukturierte Daten für LocalBusiness
  localBusiness: {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    '@id': 'https://erstehilfebottrop.de/#organization',
    name: 'Erste Hilfe Bottrop - Aktiv helfen',
    description: 'Erste-Hilfe-Kurse in Bottrop für Führerschein, Betriebe und Bildungseinrichtungen. BG/DGUV zertifiziert.',
    url: 'https://erstehilfebottrop.de',
    telephone: '+49 2041 9878 666',
    email: 'info@erstehilfebottrop.de',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Poststraße 6',
      addressLocality: 'Bottrop',
      postalCode: '46236',
      addressCountry: 'DE'
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: '51.5245',
      longitude: '6.9286'
    },
    openingHoursSpecification: {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      opens: '09:00',
      closes: '17:00'
    },
    priceRange: '€€',
    areaServed: ['Bottrop', 'Essen', 'Oberhausen', 'Gladbeck', 'Gelsenkirchen', 'Ruhrgebiet'],
    sameAs: [
      'https://www.instagram.com/erstehilfebottrop/',
      'https://www.facebook.com/erstehilfebottrop/'
    ]
  }
};

// Seitenkonfigurationen
export const pagesSeo = {
  home: {
    title: 'Erste Hilfe Kurs Bottrop | Führerschein & Betriebe | Aktiv helfen',
    description: 'Erste-Hilfe-Kurse in Bottrop ✓ Für Führerschein, Betriebe & Studenten ✓ Samstags & Sonntags ✓ BG/DGUV zertifiziert ✓ Ab 40€ ✓ Jetzt Termin buchen!',
    keywords: 'Erste Hilfe Kurs Bottrop, Führerschein Kurs Bottrop, Erste Hilfe Kurs Ruhrgebiet, BG Kurs Bottrop, Ersthelfer Ausbildung',
    canonical: '/'
  },
  termine: {
    title: 'Erste Hilfe Kurs Termine Bottrop | Jetzt online buchen',
    description: 'Aktuelle Erste-Hilfe-Kurs Termine in Bottrop ✓ Samstags & Sonntags ✓ Online buchen ✓ Sofort Teilnahmebescheinigung ✓ Ab 40€',
    keywords: 'Erste Hilfe Kurs Termine Bottrop, Erste Hilfe Kurs buchen, Wochenend Kurs Bottrop',
    canonical: '/termine'
  },
  kontakt: {
    title: 'Kontakt | Erste Hilfe Bottrop | Fragen & Beratung',
    description: 'Kontaktieren Sie uns für Fragen zu unseren Erste-Hilfe-Kursen in Bottrop. ☎ 02041 9878 666 | 📧 info@erstehilfebottrop.de',
    keywords: 'Erste Hilfe Bottrop Kontakt, Erste Hilfe Kurs Anfrage',
    canonical: '/kontakt'
  },
  betrieblich: {
    title: 'Betriebliche Ersthelfer Ausbildung Bottrop | BG/DGUV zertifiziert',
    description: 'Betriebliche Ersthelfer-Ausbildung in Bottrop ✓ BG/DGUV anerkannt ✓ Für Unternehmen ✓ Kostenübernahme durch BG möglich ✓ Jetzt anfragen!',
    keywords: 'Betrieblicher Ersthelfer Bottrop, BG Kurs Bottrop, DGUV Erste Hilfe, Ersthelfer Unternehmen',
    canonical: '/betriebliche-erste-hilfe'
  },
  brandschutz: {
    title: 'Brandschutzhelfer Ausbildung Bottrop | Zertifiziert',
    description: 'Brandschutzhelfer-Ausbildung in Bottrop ✓ Nach ASR A2.2 ✓ Theorie & Praxis ✓ Für Unternehmen ✓ Jetzt Termin anfragen!',
    keywords: 'Brandschutzhelfer Ausbildung Bottrop, Brandschutzhelfer Kurs, ASR A2.2',
    canonical: '/brandschutzhelfer'
  },
  sanitaetsdienste: {
    title: 'Sanitätsdienste Bottrop | Veranstaltungen & Events',
    description: 'Professionelle Sanitätsdienste in Bottrop für Ihre Veranstaltung ✓ Erfahrene Sanitäter ✓ Flexible Einsätze ✓ Jetzt anfragen!',
    keywords: 'Sanitätsdienst Bottrop, Sanitäter Veranstaltung, Event Sanitätsdienst',
    canonical: '/sanitaetsdienste'
  },
  ersatzbescheinigung: {
    title: 'Ersatzbescheinigung anfordern | Erste Hilfe Bottrop',
    description: 'Ersatzbescheinigung für Ihren Erste-Hilfe-Kurs in Bottrop anfordern ✓ Schnelle Bearbeitung ✓ Digital oder per Post',
    keywords: 'Ersatzbescheinigung Erste Hilfe, Bescheinigung verloren, Erste Hilfe Nachweis',
    canonical: '/ersatzbescheinigung'
  },
  impressum: {
    title: 'Impressum | Erste Hilfe Bottrop',
    description: 'Impressum und rechtliche Informationen zu Erste Hilfe Bottrop - Aktiv helfen.',
    keywords: '',
    canonical: '/impressum'
  },
  datenschutz: {
    title: 'Datenschutzerklärung | Erste Hilfe Bottrop',
    description: 'Datenschutzerklärung von Erste Hilfe Bottrop. Informationen zur Verarbeitung Ihrer personenbezogenen Daten.',
    keywords: '',
    canonical: '/datenschutz'
  },
  cookieRichtlinie: {
    title: 'Cookie-Richtlinie | Erste Hilfe Bottrop',
    description: 'Cookie-Richtlinie von Erste Hilfe Bottrop. Informationen zu den verwendeten Cookies.',
    keywords: '',
    canonical: '/cookie-richtlinie'
  },
  datenschutzSocialMedia: {
    title: 'Datenschutz Social Media | Erste Hilfe Bottrop',
    description: 'Datenschutzhinweise zu Social Media Plugins auf erstehilfebottrop.de.',
    keywords: '',
    canonical: '/datenschutz-social-media'
  }
};

// SEO Komponente
export const SEO = ({ page, customTitle, customDescription }) => {
  const config = pagesSeo[page] || pagesSeo.home;
  const title = customTitle || config.title;
  const description = customDescription || config.description;
  const canonical = `${seoConfig.siteUrl}${config.canonical}`;
  const image = seoConfig.defaultImage;

  return (
    <Helmet>
      {/* Basis Meta-Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      {config.keywords && <meta name="keywords" content={config.keywords} />}
      <link rel="canonical" href={canonical} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content={seoConfig.locale} />
      <meta property="og:site_name" content={seoConfig.siteName} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonical} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Zusätzliche Meta-Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content="Erste Hilfe Bottrop" />
      <meta name="geo.region" content="DE-NW" />
      <meta name="geo.placename" content="Bottrop" />
      
      {/* Strukturierte Daten für LocalBusiness */}
      <script type="application/ld+json">
        {JSON.stringify(seoConfig.localBusiness)}
      </script>
    </Helmet>
  );
};

export default SEO;
